import { transformToAnalyticsParams } from 'shared/infra/analytics';
import Amplitude from 'tools/amplitude/amplitude';
import type { LogAdoptionParams } from './analytics.model';

function log(params: LogAdoptionParams) {
  const transformedParams = transformToAnalyticsParams(params);
  Amplitude.logEvent('SETUP_ADOPTION_TOOLTIP', transformedParams);
}

export const adoptionAnalytics = {
  log,
};
